import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import { Break } from '~weekly-planner/lib/common';

import { TooltipPortal } from '~components';
import Icon, { faCouch, faMugHot, faUtensils } from '~components/icon';

interface ComponentProps {
  data: Break;
  style?: CSSProperties;
}

const BreakCard: React.FC<ComponentProps> = ({ data, style }) => {
  const { duration, type, is_visual } = data;
  const cardId = `break-card-${type}-${uuid()}`; // unique id per card
  const className = classNames('break-card', {
    [`${type}`]: type !== undefined,
    visualised: is_visual,
  });

  let icon;
  switch (type) {
    case 'meal': {
      icon = faUtensils;
      break;
    }
    case 'tea': {
      icon = faMugHot;
      break;
    }
    case 'shift':
    default: {
      icon = faCouch;
      break;
    }
  }

  const tooltipContent = (
    <div>
      <strong>{type.toUpperCase()} Break</strong>
      <br />
      <i>{`~${typeof duration === 'number' ? Math.round(duration) : duration}mins`}</i>
    </div>
  );

  return (
    <>
      <div id={cardId} className={className} style={style}>
        <div className="icons">
          <Icon icon={icon} size="sm" />
        </div>
        <span>{type.toUpperCase()}</span>
      </div>
      <TooltipPortal targetId={cardId} content={tooltipContent} placement="top" />
    </>
  );
};

export default BreakCard;
